<template lang='pug'>
div
  label Select Phone
  select.custom-select(name='deviceId' @change='setDevice($event.target.value)')
    option(:value="null") No Device Selected
    option(
      v-for="d in devices" 
      v-if='d.click2call_token !== null' 
      :value='d.device_id' 
      v-bind:selected='deviceId==d.device_id') {{ d.nickname }}
</template>

<script >
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['deviceId', 'device', 'userId', 'devices']),
  },
  methods: {
    setDevice(v) {
      // is the device id non-null?
      if (v===null) return;
      this.$store.commit('deviceId', v) 
    },
  },
  mounted() {
    if (!this.device) {
      console.log('mounted: no device selected, going to make user select device');
      console.log(this.devices);
      for (let i=0;i<this.devices.length;i++) {
        let d = this.devices[0];
        console.log(d);
      }
    }
  },
  beforeMount() {
    
  },
  watch: {
    devices: function() {
      if (!this.device) {
        for (let i=0;i<this.devices.length;i++) {
          let d = this.devices[i];
          if (d.type == 'mobile') {
            this.setDevice(d.device_id);
          }
        }
      }
    }
  }
}
</script>
